import { apiService } from '../APIService';
import { CRUDFactory } from '../CRUDFactory';

const namespace = 'folders';
export const CRUDFolders = CRUDFactory(namespace);

export default {
  addFiles(id, params) {
    return apiService.post(`/${namespace}/${id}/add-file`, params);
  },
  deleteFile(id, params) {
    return apiService.post(`/${namespace}/${id}/delete-file`, params);
  },
};
